import './quickRetailer.scss';

import {
    Icon,
    Input,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React, { useState } from 'react';

import { LocalizedLink } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import arrowIconBlack from '@progymedia/sbi-web-occ/src/images/icons/Icon-Fleche-Black.svg';
import arrowIconWhite from '@progymedia/sbi-web-occ/src/images/icons/Icon-Fleche.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function QuickRetailer() {
    const [postalCode, setPostalCode] = useState('');
    const { t } = useTranslation('layout');
    const positionIcon =
        'M6.056,17.637C.948,10.232,0,9.472,0,6.75a6.75,6.75,0,0,1,13.5,0c0,2.722-.948,3.482-6.056,10.887a.844.844,0,0,1-1.387,0ZM6.75,9.562A2.812,2.812,0,1,0,3.937,6.75,2.812,2.812,0,0,0,6.75,9.562Z';
    const { currentLocale } = usePageLocalization();
    const isUSA = currentLocale === 'en_US';
    const [isHover, setHover] = useState(false);

    return (
        <div className='quick-retailer'>
            {!isUSA && (
                <div className='find-retailer'>
                    <Icon
                        className='icon'
                        d={positionIcon}
                        size='20'
                        viewbox='0 0 13.5 18'
                        transform='translate(0 0)'
                        color='white'
                    />
                    <span className='find-retailer-title'>
                        {t('quick-retailer.find-retailer')}
                    </span>
                    <Input
                        placeholder={t('quick-retailer.postal-code')}
                        value={postalCode}
                        onChange={(value) => setPostalCode(value)}
                    />

                    <LocalizedLink
                        to={
                            postalCode
                                ? `/find-retailer/?searchValue=${postalCode}`
                                : `/find-retailer/`
                        }
                    >
                        <img
                            className='find-retailer-arrow'
                            onMouseEnter={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                            src={isHover ? arrowIconBlack : arrowIconWhite}
                            alt=''
                        />
                    </LocalizedLink>
                </div>
            )}
        </div>
    );
}
